/**
 * Cache e lehtë për axios GET – TTL + dedupe i kërkesave paralele të njëjta.
 * Përdoret për lista/metadata që nuk duhen freskuar çdo sekondë (kompani, pajisje, etj.).
 * Mos e përdor për pi-*-readings ose alarme nëse duhen gjithmonë “live”.
 */

const store = new Map();

function cacheKey(url, config = {}) {
  const h = config.headers || {};
  const auth = h.Authorization || h.authorization || '';
  return `${String(url)}\u0000${String(auth)}`;
}

/**
 * @param {import('axios').AxiosInstance|{get:Function}} axios
 * @param {string} url
 * @param {object} [config]
 * @param {{ ttlMs?: number, force?: boolean }} [options]
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export async function cachedAxiosGet(axios, url, config = {}, options = {}) {
  const ttlMs = options.ttlMs ?? 60_000;
  const force = options.force ?? false;
  const key = cacheKey(url, config);
  const now = Date.now();
  const hit = store.get(key);

  if (!force && hit && hit.inflight == null && hit.data !== undefined && now - hit.ts < ttlMs) {
    return {
      data: hit.data,
      status: hit.status ?? 200,
      statusText: 'OK',
      headers: hit.headers || {},
      config,
      __fromApiCache: true,
    };
  }

  if (hit?.inflight) {
    return hit.inflight;
  }

  const inflight = axios
    .get(url, config)
    .then((res) => {
      store.set(key, {
        ts: Date.now(),
        data: res.data,
        status: res.status,
        headers: res.headers,
        inflight: null,
      });
      return res;
    })
    .catch((err) => {
      const cur = store.get(key);
      if (cur) store.set(key, { ...cur, inflight: null });
      throw err;
    });

  store.set(key, { ...(hit || {}), inflight: inflight });
  return inflight;
}

/** Pastro gjithçka (p.sh. pas logout). */
export function clearApiCache() {
  store.clear();
}

/** Fshi çelësat për URL që fillon me `prefix` (për çdo Authorization). */
export function invalidateApiCacheUrlPrefix(prefix) {
  const p = String(prefix);
  const sep = '\u0000';
  for (const k of [...store.keys()]) {
    const urlPart = k.includes(sep) ? k.slice(0, k.indexOf(sep)) : k;
    if (urlPart.startsWith(p)) store.delete(k);
  }
}
